export default __webpack_public_path__ + "static/media/1765.7fa29616.png";